import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';

const Header = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const { isDark } = useTheme();

  const scrollToOrderForm = () => {
    const orderForm = document.getElementById('order-form');
    if (orderForm) {
      orderForm.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      {/* Skip to main content link for accessibility */}
      <a href="#order-form" className="skip-link sr-only focus:not-sr-only focus:absolute focus:top-0 focus:left-0 bg-primary text-white px-4 py-2 z-[100]">
        Skip to main content
      </a>
      
      <header className={`sticky top-0 z-40 w-full backdrop-blur-lg border-b transition-all duration-300 ${
        isDark 
          ? 'bg-slate-900/95 border-slate-700/50' 
          : 'bg-[#fff7fb]/95 border-[#f2bfd4]/70 shadow-sm'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 sm:h-18">
            {/* Logo */}
            <a href="/" className="flex-shrink-0 flex items-center gap-2.5 cursor-pointer group" aria-label="Loren Aura Home">
              <img src="/LorenAura.png" alt="Loren Aura" className="h-9 w-9" width="36" height="36" decoding="async" />
              <h1 className={`text-xl font-bold tracking-tight group-hover:text-primary transition-colors duration-300 ${
                isDark ? 'text-white' : 'text-[#2d1c2b]'
              }`}>
                <span className="text-metallic">Loren Aura</span>
              </h1>
            </a>
            
            <div className="flex items-center gap-2 sm:gap-4">
              {/* Navigation */}
              <nav className="hidden md:flex gap-6" aria-label="Main navigation">
                <a 
                  className={`text-sm font-medium hover:text-primary transition-colors duration-200 py-2 ${
                    isDark ? 'text-slate-300' : 'text-[#4b3a2a]'
                  }`} 
                  href="#reviews"
                >
                  {t.nav.reviews}
                </a>
                <a 
                  className={`text-sm font-medium hover:text-primary transition-colors duration-200 py-2 ${
                    isDark ? 'text-slate-300' : 'text-[#4b3a2a]'
                  }`} 
                  href="#faq"
                >
                  {t.nav.faq}
                </a>
              </nav>
              
              {/* Language Toggle - Accessible button */}
              <button 
                onClick={toggleLanguage}
                className={`flex items-center justify-center min-w-[44px] min-h-[44px] px-3 rounded-full border-2 transition-all duration-200 text-sm font-semibold ${
                  isDark 
                    ? 'border-slate-600 hover:border-primary text-white hover:text-primary' 
                    : 'border-[#f2bfd4] hover:border-primary text-[#4b3a2a] hover:text-primary'
                }`}
                aria-label={language === 'en' ? 'Switch to Bangla' : 'Switch to English'}
              >
                <span>{language === 'en' ? 'বাং' : 'EN'}</span>
              </button>
              
              {/* Theme Toggle disabled for now */}
              
              {/* CTA Button - Prominent, accessible */}
              <button 
                onClick={scrollToOrderForm}
                className="hidden sm:flex items-center justify-center rounded-full border-2 border-[#f2a1c4] bg-[#E24C8B] text-white font-bold text-sm px-6 min-h-[44px] shadow-[0_10px_20px_-14px_rgba(226,76,139,0.7)] transition-all duration-200 hover:bg-[#C83E78] hover:shadow-[0_16px_24px_-18px_rgba(226,76,139,0.85)] hover:scale-[1.02]"
                aria-label={t.nav.order}
              >
                {t.nav.order}
              </button>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;

